import Link from "components/templatesComponents/Link";
import PropTypes from "prop-types";
import React from "react";
import { accentColorDsfrTypes } from "utils/colorDsfrTypes";

const TagLink = (props) => {
  const { tag, color = "", url, size = "md", iconDSFR = "", ...linkProps } = props;

  let tagClassName = "fr-tag";
  if (color) {
    tagClassName += ` fr-tag--${color}`;
  }
  if (size === "sm") {
    tagClassName += " fr-tag--sm";
  }
  if (iconDSFR) {
    tagClassName += ` fr-icon-${iconDSFR} fr-tag--icon-left`;
  }

  return (
    <Link basic className={tagClassName} url={`${url}?tag=${tag}`} {...linkProps}>
      {tag}
    </Link>
  );
};

TagLink.propTypes = {
  tag: PropTypes.string.isRequired,
  color: PropTypes.oneOf(accentColorDsfrTypes),
  url: PropTypes.string.isRequired,
  size: PropTypes.oneOf(["sm", "md"]),
  iconDSFR: PropTypes.string,
};

export default TagLink;
